import React from 'react';
import { PropTypes } from 'prop-types';
import { TablePagination } from '@mui/material';

// Paging control for the usage cards. Sits in the `footer` slot of
// UsageOverTimeChart / UsageHeatmap, below the chart, which is where paging
// lives everywhere else in the admin.
//
// Wraps the same MUI TablePagination that DynamicTable uses, so the chart cards
// and the tables under them page identically — same "1-15 of 37" phrasing, same
// right alignment, same arrow affordances and aria labels. The rows-per-page
// selector is suppressed (`rowsPerPageOptions={[]}`): page size is fixed per card.
//
// Always rendered, including when everything fits on one page — the arrows just
// disable themselves. Hiding it entirely made the card look like it had no paging
// at all on small datasets (a dev environment with 2 clients, say), and the count
// is worth showing on its own: it tells you how many clients are behind the chart.
export function UsagePager({ page, pageSize, total, unit, onChange }) {
  return (
    <TablePagination
      component='div'
      count={total}
      page={page}
      rowsPerPage={pageSize}
      rowsPerPageOptions={[]}
      onPageChange={(e, next) => onChange(next)}
      // DynamicTable labels its arrows with back/nextIconButtonProps, which MUI 7
      // still honors but has deprecated in favor of slotProps.actions — use the
      // supported spelling here so this doesn't break on the next MUI bump.
      slotProps={{
        actions: {
          previousButton: { 'aria-label': 'Previous Page' },
          nextButton: { 'aria-label': 'Next Page' },
        },
      }}
      labelDisplayedRows={({ from, to, count }) => (
        `${from.toLocaleString()}-${to.toLocaleString()} of ${count.toLocaleString()}${unit ? ` ${unit}` : ''}`
      )}
    />
  );
}

UsagePager.propTypes = {
  page: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  unit: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
